"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const List = (props) => {
    const { id, items, ordered, decorated = true, inline, itemMarkerUrl = '', lineHeight } = props, rest = __rest(props, ["id", "items", "ordered", "decorated", "inline", "itemMarkerUrl", "lineHeight"]);
    const listItems = items.map((item, index) => (react_1.default.createElement(styles_1.StyledListItem, { key: index, decorated: decorated, inline: inline, itemMarkerUrl: itemMarkerUrl, lineHeight: lineHeight }, item)));
    return ordered ? (react_1.default.createElement(styles_1.StyledOrderedList, Object.assign({ id: id }, rest), listItems)) : (react_1.default.createElement(styles_1.StyledUnorderedList, Object.assign({ id: id }, rest), listItems));
};
exports.List = List;
